import React, { useEffect, useState } from "react";
import { Display, Icon } from "../Main/styles";
import { DBFilterCheckboxArea, DBFilterWrapper, DBTableExcelBtn, DateArea } from "../DB/styles";
import { ConfigProvider, Input, Table, DatePicker, Select, Checkbox, message } from "antd";
import { FaGear, FaPen } from "react-icons/fa6";
// import { SearchArea } from './styles'
import { FaSearch } from "react-icons/fa";
import { useBoardList } from "CRM/hooks/GetBoardList";
import dayjs from "dayjs";
import "dayjs/locale/ko";
import { RangePickerProps } from "rc-picker/es/RangePicker.d";
import { useMyInfo } from "../../hooks/GetMyInfo";
import API from "../../../utils/api";
import { useToken } from "../../../app/hooks";
import { useIsMobile } from "../../components/IsMobile";
import { ReactComponent as FilterArrowBottom } from "../../../assets/FilterArrowBottom.svg";
import styled from "styled-components";
import { useNoticeList } from "../../hooks/GetNoticeList";
import { NoticeAdd } from "../../components/Add/NoticeAdd";
import { NoticeView } from "../../components/NoticeView";
const { RangePicker } = DatePicker;

export const Notice = () => {
	const IsMobile = useIsMobile();
	const [scrollPosition, setScrollPosition] = useState(0);
	const { data: token } = useToken();
	const [createdAt, setCreatedAt] = useState<RangePickerProps<dayjs.Dayjs>["value"] | any>([null, null]);
	const [inputCreated, setInputCreated] = useState<RangePickerProps<dayjs.Dayjs>["value"] | any>([null, null]);
	const [search, setSearch] = useState("");
	const [inputSearch, setInputSearch] = useState("");
	// const { boardList, mutate } = useBoardList(
	//   search,
	//   createdAt?.[0] !== null
	//     ? `${dayjs(createdAt?.[0])?.format('YYYY-MM-DD')}~${dayjs(createdAt?.[1])?.format(
	//       'YYYY-MM-DD'
	//     )}`
	//     : ''
	// )
	const [isRequest, setIsRequest] = useState(false);
	const [isSelect, setIsSelect] = useState(false);
	const [boardId, setBoardId] = useState<any>(null);
	const [status, setStatus] = useState("0");
	const [selectedRows, setSelectedRows] = useState<number[]>([]);
	const [isAllChecked, setIsAllChecked] = useState(false);
	const [localNoticeList, setLocalNoticeList] = useState<any>([]);
	// const filterList = boardList?.filter(it => it.status == status)

	const { myInfo } = useMyInfo();

	const [isSetTemplate, setIsSetTemplate] = useState(false);

	const [isFilter, setIsFilter] = useState(false);

	const { noticeList, mutate: noticeMutate } = useNoticeList();

	// 필터링 공지사항 - 본사 직원 핸들링, branchId:1
	useEffect(() => {
		if (myInfo?.master === 1) {
			setLocalNoticeList(noticeList);
		} else if (myInfo?.branchId !== 1) {
			setLocalNoticeList(noticeList?.filter((it) => it?.branchName !== "본사"));
		} else {
			setLocalNoticeList(noticeList);
		}
	}, [noticeList]);

	useEffect(() => {
		if (!isSelect && IsMobile) {
			window.scrollTo({ top: scrollPosition, behavior: "smooth" });
		} else if (isSelect && IsMobile) {
			window.scrollTo({ top: 0, behavior: "smooth" });
			setScrollPosition(window.scrollY);
		}
	}, [isSelect]);

	const clickSearch = () => {
		setCreatedAt(inputCreated);
		setSearch(inputSearch);
	};

	const handleSelectAllChange = (e) => {
		setIsAllChecked(e.target.checked);
		const ids = localNoticeList.map((db) => db.id);
		setSelectedRows(e.target.checked ? ids : []);
	};

	const handleCheckboxChange = (e, id) => {
		if (e.target.checked) {
			setSelectedRows([...selectedRows, id]);
		} else {
			setSelectedRows(selectedRows?.filter((rowId) => rowId !== id));
		}
	};

	const clickDelete = () => {
		const shouldEdit = window.confirm(`선택한 글을 삭제하시겠습니까?`);
		if (shouldEdit) {
			if (selectedRows?.length == 0) {
				message.error("선택한 글이 없습니다.");
			} else {
				API.delete("/board/notice", token + "", {
					ids: selectedRows,
				})
					.then((res: any) => {
						if (res.result.success) {
							message.success("삭제되었습니다.");
							noticeMutate();
						}
					})
					.catch((err: any) => {});
			}
		}
	};

	const mobileColumns = [
		{
			dataIndex: "checkbox",
			title: <Checkbox checked={isAllChecked} onChange={handleSelectAllChange} />,
			render: (value, data) => {
				return (
					<div className="checkbox">
						<Checkbox
							style={{ justifyContent: "center", display: "flex" }}
							checked={selectedRows?.includes(data.id)}
							key={data?.id}
							onChange={(e) => handleCheckboxChange(e, data?.id)}
						/>
					</div>
				);
			},
		},
		{
			dataIndex: "",
			title: "공지사항",
			render: (value, data) => {
				// console.log(data)
				return (
					<>
						<div
							className="request"
							style={{ display: "flex", justifyContent: "flex-start", color: "#437EFF", cursor: "pointer" }}
							onClick={() => {
								setBoardId(data?.id);
								setIsSelect(true);
							}}
						>
							<p style={{ marginRight: 4, fontWeight: "bold" }}>제목: </p>
							{data?.title}
						</div>
						<div
							className="tel"
							style={{ display: "flex", justifyContent: "flex-start" }}
							onClick={() => {
								setBoardId(data?.id);
								setIsSelect(true);
							}}
						>
							<p style={{ marginRight: 4, fontWeight: "bold" }}>작성일: </p>
							{data?.createdAt}
						</div>
						<div className="path" style={{ display: "flex", justifyContent: "flex-start" }}>
							<p style={{ marginRight: 4, fontWeight: "bold" }}>지사: </p> {data?.branchName}
						</div>
					</>
				);
			},
		},
	];

	const columns = [
		{
			dataIndex: "checkbox",
			title: <Checkbox checked={isAllChecked} onChange={handleSelectAllChange} />,
			render: (value, data) => {
				return (
					<div className="checkbox">
						<Checkbox
							style={{ justifyContent: "center", display: "flex" }}
							checked={selectedRows?.includes(data.id)}
							key={data?.id}
							onChange={(e) => handleCheckboxChange(e, data?.id)}
						/>
					</div>
				);
			},
		},
		{
			dataIndex: "",
			title: "제목",
			render: (value, data) => {
				return (
					<div
						className="title"
						style={{
							display: "flex",
							justifyContent: "center",
							textDecoration: "underline",
							color: "#437EFF",
							cursor: "pointer",
						}}
						onClick={() => {
							setBoardId(data?.id);
							setIsSelect(true);
						}}
					>
						{data?.title}
					</div>
				);
			},
		},
		{
			dataIndex: "branchName",
			title: "지사명",
			render: (value, data) => {
				return (
					<div className="path" style={{ display: "flex", justifyContent: "center" }}>
						{data?.branchName}
					</div>
				);
			},
		},
		{
			dataIndex: "createdAt",
			title: "작성일",
			render: (value, data) => {
				return (
					<div style={{ display: "flex", justifyContent: "center" }} className="tel">
						{data?.createdAt}
					</div>
				);
			},
		},
	];

	return (
		<Display IsMobile={IsMobile}>
			<DBFilterWrapper>
				{IsMobile ? (
					<>
						<DBFilterCheckboxArea IsMobile={IsMobile} style={{ flexDirection: "row" }}>
							<div style={{ display: "flex", gap: 10 }}>
								<DBTableExcelBtn
									onClick={() => setIsRequest(true)}
									style={{ backgroundColor: "#437eff", color: "#fff" }}
								>
									<Icon>
										<FaPen />
									</Icon>
									업무 요청
								</DBTableExcelBtn>
							</div>

							<div style={{ display: "flex", gap: 10 }}>
								{myInfo?.master && (
									<DBTableExcelBtn
										onClick={clickDelete}
										style={{ backgroundColor: "#f93e3e", color: "#fff" }}
									>
										선택 삭제
									</DBTableExcelBtn>
								)}
							</div>
						</DBFilterCheckboxArea>
					</>
				) : (
					<DBFilterCheckboxArea IsMobile={IsMobile}>
						<div style={{ display: "flex", gap: 10 }}>
							<DBTableExcelBtn
								onClick={() => setIsRequest(true)}
								style={{ backgroundColor: "#437eff", color: "#fff" }}
							>
								<Icon>
									<FaPen />
								</Icon>
								글쓰기
							</DBTableExcelBtn>
						</div>

						<div style={{ display: "flex", gap: 10 }}>
							{myInfo?.master && (
								<DBTableExcelBtn onClick={clickDelete} style={{ backgroundColor: "#f93e3e", color: "#fff" }}>
									선택 삭제
								</DBTableExcelBtn>
							)}
						</div>
					</DBFilterCheckboxArea>
				)}

				<Table dataSource={localNoticeList} columns={IsMobile ? mobileColumns : columns} bordered={true} />
			</DBFilterWrapper>
			{isRequest && <NoticeAdd setIsRequest={setIsRequest} mutate={noticeMutate} boardId={boardId} setBoardId={setBoardId} />}
			{boardId !== null && <NoticeAdd setIsRequest={setIsRequest} mutate={noticeMutate} boardId={boardId} setBoardId={setBoardId} />}
		</Display>
	);
};

export default React.memo(Notice);

const RotatedSvg = styled(FilterArrowBottom)`
	transform: rotate(180deg);
	width: 45px;
	height: 25px;
`;
